import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  CustomComponentEnhanced,
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import { storeKey } from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseHomeBaseData } from './ConfigData'
import { HomeBaseSettings } from './Settings'

type HomeBase = CustomComponentEnhanced<HomeBaseSettings>
export const History = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const queryKey = [storeKey, componentID, 'history']
  const current = useGetCustomComponent<HomeBaseSettings>(componentID)

  const update = useUpdateCustomComponent<HomeBaseSettings>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseHomeBaseData
  )

  const parseData = (data?: HomeBase | null) => {
    if (!data) return {} as HomeBase
    return pick(['name', 'description', 'settings', 'type'], data) as HomeBase
  }
  const restoreVersion = async (data: Record<string, unknown>) => {
    const restoredData = parseData(data as unknown as HomeBase)
    if (!restoredData) return
    await update.mutateAsync(restoredData)
  }
  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(current.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
